//export const SERVER_URL = "http://localhost:8040";
export const SERVER_URL = "http://itogallarate.etito.it:8020";


// WEBPACK FOOTER //
// ./src/config.ts